import { render, staticRenderFns } from "./Schedule2.vue?vue&type=template&id=38b53003&scoped=true&"
import script from "./Schedule2.vue?vue&type=script&lang=ts&"
export * from "./Schedule2.vue?vue&type=script&lang=ts&"
import style0 from "./Schedule2.vue?vue&type=style&index=0&id=38b53003&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b53003",
  null
  
)

export default component.exports